module.exports = __webpack_public_path__ + "static/c_hyun-79bb9b1605c79fce2da917d2ec3854ea.jpg";